import {
  organizerBulkUpsertTablesApi,
  organizerCreateClubApi,
  organizerListTablesApi,
  organizerUpdateClubApi,
} from "../../../api/api";
import { cumpleanosParaClubNuevo } from "../../importarConfig/configImportada";
import {
  aplicarDetalle,
  aplicarReglas,
  canchasImportadas,
  canchasIniciales,
  categoriasDe,
  formDataContacto,
  formDataCrearClub,
  formDataFotos,
  formDataPoliticas,
  formDataServicios,
  hayFotos,
  payloadCanchas,
} from "./clubPayload";

export const crearClub = async (d) => {
  const res = await organizerCreateClubApi(formDataCrearClub(d));
  const club = res?.data?.info || {};
  const id = club._id || club.id;
  if (!id) throw new Error("No pudimos confirmar el club creado. Revisá el módulo de canchas.");
  return { id, club };
};

// Bulk upsert: full replace by name, so `modelos` must hold every court with all its pricing.
const guardarCanchas = (clubId, modelos, opts) => organizerBulkUpsertTablesApi(clubId, payloadCanchas(modelos, opts));

// Birthdays of a copied club need the new courts' ids, so they go after the courts. Best effort: the
// club stays created and the returned notices say what was not copied.
const copiarCumpleanos = async (clubId, birthdays) => {
  try {
    const res = await organizerListTablesApi(clubId);
    const canchas = (Array.isArray(res?.data?.info) ? res.data.info : []).filter((t) => t.status !== false);
    const { payload, avisos } = cumpleanosParaClubNuevo(birthdays, canchas);
    if (!payload) return avisos;
    const fd = new FormData();
    fd.append("clubId", clubId);
    fd.append("birthdays", JSON.stringify(payload));
    await organizerUpdateClubApi(fd);
    return avisos;
  } catch (e) {
    return ["No pudimos copiar la configuración de cumpleaños: cargala desde la pestaña Cumpleaños del club."];
  }
};

/**
 * Publishes the club: creates it and then its courts. `progreso` survives retries: when the courts
 * fail after the club was created, calling again only retries the courts (never a second club).
 * A copied club (`d.importado`) also gets its courts' details and rules, then its birthdays.
 * Returns the context the optional steps use; `avisos` lists what a copy could not do.
 */
export const publicarClub = async (d, progreso, { soloGratis = false } = {}) => {
  if (!progreso.club) progreso.club = await crearClub(d);
  const modelos = d.importado ? canchasImportadas(d) : canchasIniciales(d);
  await guardarCanchas(progreso.club.id, modelos, { sinSenas: soloGratis });
  let avisos = [];
  if (d.importado && !progreso.cumpleanosIntentado) {
    progreso.cumpleanosIntentado = true;
    avisos = await copiarCumpleanos(progreso.club.id, d.importado.birthdays);
  }
  return {
    ...progreso.club,
    canchas: modelos,
    categorias: d.importado ? categoriasDe(d.categorias) : [],
    ...(avisos.length ? { avisos } : {}),
  };
};

// Saves one optional step through the same endpoints the club form uses; skipping saves nothing.
// `ctx.canchas` is what the backend holds right now: each courts save changes only its own fields.
export const guardarOpcional = async (paso, d, ctx, { sinSenas = false } = {}) => {
  const { id } = ctx;
  switch (paso.id) {
    case "contacto":
      await organizerUpdateClubApi(formDataContacto(id, d));
      return;
    case "fotos":
      if (hayFotos(d)) await organizerUpdateClubApi(formDataFotos(id, d));
      return;
    case "servicios":
      await organizerUpdateClubApi(formDataServicios(id, d));
      ctx.categorias = categoriasDe(d.categorias);
      return;
    case "politicas":
      await organizerUpdateClubApi(formDataPoliticas(id, d));
      return;
    case "detalle": {
      const siguientes = aplicarDetalle(ctx.canchas, d);
      await guardarCanchas(id, siguientes, { sinSenas });
      ctx.canchas = siguientes;
      return;
    }
    case "reglas": {
      const siguientes = aplicarReglas(ctx.canchas, d);
      await guardarCanchas(id, siguientes, { sinSenas });
      ctx.canchas = siguientes;
      return;
    }
    default:
  }
};
